import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { filter, map, shareReplay, tap } from "rxjs/operators";

import { VmManager } from "@onsip/common/services/api/resources/vmManager/vm-manager";
import { VoicemailManagementService } from "@onsip/common/services/api/resources/vmManager/vm-manager.service";
import { AddressSummaryService } from "@onsip/common/services/api/resources/addressSummary/address-summary.service";
import { views } from "@onsip/web/app/phone/views";
import { UserAliasService } from "@onsip/common/services/api/resources/userAlias/user-alias.service";

@Component({
  selector: "onsip-voicemail-manager",
  templateUrl: "./voicemail-manager.component.html",
  styleUrls: ["./voicemail-manager.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class VoicemailManagerComponent implements OnInit {
  voicePanel$ = new BehaviorSubject<"view" | "edit">("view");
  voicemailManagement$ = this.vmManagerService.state.pipe(
    filter(state => !state.loading),
    map(({ state }) => Object.values(state) as Array<VmManager>),
    map(([vmManagementAddress]) => vmManagementAddress),
    tap(() => {
      this.isDataObtained$.next(true);
    }),
    shareReplay({ bufferSize: 1, refCount: false })
  );

  togglePanel(panel: "view" | "edit"): void {
    this.voicePanel$.next(panel);
  }

  views = views;
  isDataObtained$ = new BehaviorSubject(false);

  constructor(
    private vmManagerService: VoicemailManagementService,
    private addressSummaryService: AddressSummaryService,
    private userAliasService: UserAliasService
  ) {}

  ngOnInit(): void {
    this.getDataSources();
  }

  private getDataSources(): void {
    this.vmManagerService.voicemailManagementAddressBrowse();
    this.addressSummaryService.addressSummaryBrowse();
    this.userAliasService.userAliasBrowse();
  }
}
